var cell_default = {
  "cell": "UUInS",
  "header": "_-71v8",
  "selected": "DaygO",
  "editing": "ch6ir",
  "singleSelection": "_4yJMI",
  "hideLastBlock": "Fziq3",
  "editorWrapper": "pIFkV",
  "viewerWrapper": "IrkKH",
  "hideFirstBlock": "v6ny3",
  "editor": "-Wnn7",
  "edit": "RzLJQ",
  "view": "ILk91",
  "editingToolbarWrapper": "W-lV9",
  "selectAll": "_2WPGp",
  "disableSelection": "_9vfG0"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
